export var normalizeBoolean = function(value) {
  if (typeof value === "boolean") {
    var promisified_1 = Promise.resolve(value);
    return function() {
      return promisified_1;
    };
  }
  return value;
};
